import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { AiOutlineClose } from "react-icons/ai";
import { NavLink, useParams } from "react-router-dom";
import { FaGoogleDrive } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { FaLink } from "react-icons/fa";
import { notifyDanger, notifySuccess } from "../../actions/customFn";
import axios from "../../api/axios";
import { asyncSendNotification } from "../../actions/notificationApi";
import { useDispatch } from "react-redux";

const DUMMY_DATA = [
  {
    title: "FIle.pdf",
  },
  {
    title: "FIle.txt",
  },
  {
    title: "FIle.xl",
  },
];

const SubmissionModal = ({
  modalShow,
  setShowModal,
  data,
  setIsLoading,
  setIsUpdate,
  work_type,
  title,
}) => {
  console.log("Data from props", data);
  const RatingData = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  const [rating, setRating] = useState(1);
  const [remark, setRemark] = useState("");
  const { id } = useParams();

  const dispatch = useDispatch()

  const getFileExtension = (filename) => {
    if(typeof filename === "string" && filename !== "") {
      const parts = filename?.split(".");
      return parts[parts.length - 1].toLowerCase();
    } else if (typeof filename === "object" && Object.keys(filename).length > 0) {
      const parts = filename?.name?.split(".");
      return parts[parts.length - 1].toLowerCase();
    }
  };

  useEffect(() => {
    if (data) {
      if (data.rating) {
        setRating(data.rating);
      }
      if (data.remark) {
        setRemark(data.remark);
      }
    }
  }, [data]);

  const handleRatingSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    const url = `/batch/assignment/rating/`;
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("skillanthem_auth")}`,
      },
    };
    const formData = { id, userId: data?.user?._id || null, rating, remark };
    axios
      .put(url, formData, config)
      .then((res) => {
        const { message } = res.data;
        setShowModal(false);
        notifySuccess(message);
        setIsUpdate((p) => !p);
        const formData = {
          recipientArr: [data?.user?._id],
          messages: {
            notification_msg: `
            Your ${work_type} titled <b>${title}</b> has been reviewed. Please check the rating and remarks provided for improvement.`,
            date: new Date(),
            notification_type: "work",
          },
        };
        dispatch(asyncSendNotification(formData));
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
        notifyDanger(err.response.data.message || "Some Error Occured!");
      });
  };

  return (
    <Modal
      centered
      className="bootstrap-modal-custom submission-modal"
      show={modalShow}
      onHide={() => setShowModal(false)}
    >
      <Modal.Body style={{backgroundColor:"#292929"}}>
        <AiOutlineClose
          className="modal-close-btn"
          onClick={() => setShowModal(false)}
        />
        <div
  style={{
    background: '#292929',
    color: 'white',
    padding: '20px',
    borderRadius: '10px',
  }}
>
  {/* Heading */}
  <div style={{ marginBottom: '16px' }}>
    <h2 style={{ color: '#10b981', margin: 0 }}>Submission</h2>
  </div>

  {/* Student Works */}
  <div style={{ marginBottom: '20px' }}>
    <label style={{ fontWeight: 500 }}>Student’s Works</label>

    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', marginTop: '10px' }}>
      {data?.projectFiles.map((file, i) => (
        <div key={i} style={{ width: '30%' }}>
          <div
            style={{
              background: '#1f1f1f',
              padding: '12px',
              borderRadius: '8px',
              border: '1px solid #444',
            }}
          >
            <h4 style={{ margin: '0 0 8px 0', color: '#10b981' }}>
              file{i + 1}.{getFileExtension(file)}
            </h4>

            <NavLink
              target="_blank"
              to={
                typeof file === 'string'
                  ? file
                  : Object.keys(file).length > 0
                  ? file?.url
                  : '#'
              }
              style={{ color: '#60a5fa', textDecoration: 'underline' }}
            >
              view
            </NavLink>
          </div>
        </div>
      ))}
    </div>
  </div>

  {/* Drive Link */}
  {data?.drive_url && (
    <div style={{ marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
      <FaGoogleDrive />
      <NavLink to={data.drive_url} target="_blank" style={{ color: '#60a5fa' }}>
        <span>google_drive_url</span> <FaLink />
      </NavLink>
    </div>
  )}

  {/* LinkedIn Link */}
  {data?.postUrl && (
    <div style={{ marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '8px' }}>
      <FaLinkedin />
      <NavLink to={data.postUrl} target="_blank" style={{ color: '#60a5fa' }}>
        <span>linkedin_url</span> <FaLink />
      </NavLink>
    </div>
  )}

  {/* Rating */}
  <div style={{ marginBottom: '20px' }}>
    <label style={{ fontWeight: 500 }}>Rating</label>

    <ul
      style={{
        display: 'flex',
        gap: '10px',
        listStyle: 'none',
        padding: 0,
        marginTop: '10px',
      }}
    >
      {RatingData.map((data, i) => (
        <li
          key={i}
          onClick={() => setRating(data)}
          style={{
            padding: '8px 12px',
            borderRadius: '6px',
            cursor: 'pointer',
            background: rating === data ? '#10b981' : '#1f1f1f',
            color: rating === data ? '#000' : '#fff',
            border: '1px solid #444',
          }}
        >
          {data}
        </li>
      ))}
    </ul>
  </div>

  {/* Remark Form */}
  <form onSubmit={handleRatingSubmit}>
    <div style={{ marginBottom: '16px' }}>
      <label style={{ fontWeight: 500 }}>Remark</label>

      <textarea
        rows={3}
        value={remark}
        onChange={(e) => setRemark(e.target.value)}
        required
        style={{
          width: '100%',
          marginTop: '8px',
          padding: '10px',
          borderRadius: '6px',
          border: '1px solid #444',
          background: '#1f1f1f',
          color: 'white',
        }}
      />
    </div>

    <div>
      <button
        style={{
          background: '#10b981',
          color: '#000',
          border: 'none',
          padding: '10px 16px',
          borderRadius: '6px',
          cursor: 'pointer',
          fontWeight: 600,
        }}
      >
        Give Rating
      </button>
    </div>
  </form>
</div>
      </Modal.Body>
    </Modal>
  );
};

export default SubmissionModal;
